import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { newsService } from '../services/api';
import { NewsItem } from '../types';
import NewsContent from '../components/NewsContent';
import { resolvePublicMediaUrl } from '../utils/newsContent';
import '../styles/NewsDetail.css';

const NewsDetail: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const [news, setNews] = useState<NewsItem | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const load = async () => {
            if (!id) return;
            try {
                setLoading(true);
                const data = await newsService.getNewsById(Number(id));
                setNews(data);
            } catch (err) {
                console.error('Erro ao carregar notícia', err);
                setError('Notícia não encontrada.');
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [id]);

    const formatDate = (value?: string) => {
        if (!value) return '';
        const d = new Date(value);
        return d.toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    };

    if (loading) {
        return (
            <div className="news-detail-page">
                <div className="container">
                    <div className="loading">Loading news...</div>
                </div>
            </div>
        );
    }

    if (error || !news) {
        return (
            <div className="news-detail-page">
                <div className="container">
                    <p className="error-message">{error || 'Notícia não encontrada.'}</p>
                    <button className="btn btn-secondary" onClick={() => navigate('/news')}>
                        Back to News
                    </button>
                </div>
            </div>
        );
    }

    const coverImage = resolvePublicMediaUrl(news.imageUrl);

    return (
        <div className="news-detail-page">
            <div className="container">
                <div className="breadcrumb">
                    <Link to="/news">News</Link> <span>/</span> <span>{news.title}</span>
                </div>

                <article className="news-article">
                    <header className="news-header">
                        <div className="meta">
                            <span className="date">{formatDate(news.createdAt)}</span>
                            {news.author && <span className="author">By {news.author}</span>}
                            {news.category && <span className="category">{news.category}</span>}
                        </div>
                        <h1>{news.title}</h1>
                    </header>

                    {coverImage && (
                        <div className="news-image">
                            <img src={coverImage} alt={news.title} loading="lazy" />
                        </div>
                    )}

                    <NewsContent content={news.content} className="news-content" />
                </article>
            </div>
        </div>
    );
};

export default NewsDetail;

